import { faqData } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-xl md:text-2xl font-extrabold text-foreground-900">常见问题</h2>
          <p className="text-sm text-foreground-600 mt-2">关于91视频网站的常见疑问解答，帮助你快速了解平台</p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqData.map((item) => (
            <details key={item.id} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">{item.question}</h3>
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:hidden">
                  <i className="ri-add-line"></i>
                </div>
                <div className="w-5 h-5 items-center justify-center flex-shrink-0 text-foreground-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-700 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}